import React from 'react';

const PriceSkeleton = ({ cards = 3, compact = false }) => (
  <div
    className={`grid gap-6 ${cards > 1 ? 'md:grid-cols-3' : ''}`}
    role="status"
    aria-busy="true"
    aria-label="Loading regional prices"
  >
    {Array.from({ length: cards }, (_, index) => (
      <div
        key={index}
        className={`animate-pulse rounded-2xl border border-white/10 bg-white/[0.025] ${
          compact ? 'p-4' : 'p-8'
        }`}
      >
        <div className="h-5 w-2/5 rounded bg-white/10" />
        <div className="mt-5 h-10 w-3/5 rounded bg-[#00FFD1]/10" />
        {!compact && (
          <>
            <div className="mt-8 h-3 w-full rounded bg-white/[0.07]" />
            <div className="mt-3 h-3 w-4/5 rounded bg-white/[0.07]" />
            <div className="mt-3 h-3 w-3/5 rounded bg-white/[0.07]" />
          </>
        )}
      </div>
    ))}
    <span className="sr-only">Regional prices are being detected.</span>
  </div>
);

export default PriceSkeleton;
